import $ from 'jquery';
import { scrollToDiv } from './../../scripts/helpers';
/**
 * ContactGridV1 widget configs
 */
const contactGridV1Semantics = {
    'mainWrapClass': 'contact-grid-v1',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'elementClass': 'contact-grid-v1__address-more',
};

/**
 * ContactGridV1 initializer
 */
$(function () {
    ContactGridV1.init();
});

class ContactGridV1 {
    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        if ($(`.${contactGridV1Semantics.mainWrapClass}`).length === 0) {
            return false;
        }
        if (!window || !window.widgets || !window.widgets.contactGridV1) {
            window.widgets.contactGridV1 = new ContactGridV1();
        }

        /**
         * Checking other instances
         */
        $(`.${contactGridV1Semantics.mainWrapClass}`).each((index, el) => {
            let isInitialized =
                ($(el).attr(`${contactGridV1Semantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized) {
                window.widgets.contactGridV1.registerInstance($(el));
                window.widgets.contactGridV1.registerListeners($(el));
            }
        });
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${contactGridV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        try {
            // TODO[dependDetected]: slick plugin
            let object = el.find(`.${contactGridV1Semantics.mainWrapClass}`);
            el.attr(`${contactGridV1Semantics.isInitializedAttribute}`, true);
            window.widgets.contactGridV1.pluginInstances[instanceId] = object;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
        let elements = $(`.${contactGridV1Semantics.mainWrapClass}[${
                contactGridV1Semantics
                        .instanceIdAttribute
        }="${
                el.attr(contactGridV1Semantics
                        .instanceIdAttribute)
        }"]`);

        elements.on(
            'click',
            `.${contactGridV1Semantics.elementClass}`,
            (e) => {
                e.preventDefault();
                let current = $(e.currentTarget);
                if(
                    window.widgets && window.widgets.yaMapV1
                    && typeof window.widgets.yaMapV1.pluginInstances === 'object'
                    && Object.keys(window.widgets.yaMapV1.pluginInstances).length > 0
                )
                {
                    let firstMapId = Object.keys(window.widgets.yaMapV1.pluginInstances)[0];
                    //DEPS
                    scrollToDiv($(`#${firstMapId}`),60);
                }
                else{
                     console.log('NOT_EXIST');
                    console.log(window.widgets);
                }

            }
        );
    }

    reInit(instanceId) {
        ContactGridV1.init();
    }
}